export const firebaseConfig = {
  apiKey: "AIzaSyDqgXgVtZHoblsx1P4sFdp_x9m_okU4pyM",
  authDomain: "react-note-manager-587e6.firebaseapp.com",
  projectId: "react-note-manager-587e6",
  storageBucket: "react-note-manager-587e6.appspot.com",
  messagingSenderId: "933781859000",
  appId: "1:933781859000:web:4d344520c0e25cf7c0a24d",
};
